<template>
  <div class="container">
    <topHeader title="应用中心" return-path="Home"></topHeader>
    <div class="main-content">
      <div class="main-top">
        <div class="top-content">
          <div class="top-title-content">
            <div class="top-title">首页应用</div>
            <div
              v-if="!isEdit"
              class="top-btn"
              style="color: #fa5050; background: #fff"
              @click="isEdit = true"
            >
              编辑
            </div>
            <div
              v-if="isEdit"
              class="top-btn"
              style="color: #fff; background: #fa5050"
              @click="editUserConfigFn"
            >
              保存
            </div>
          </div>
          <CommonBorder></CommonBorder>
          <div class="top-list-content">
            <div
              v-for="(item, index) in homeApp.config"
              :key="index"
              class="top-list-item"
            >
              <div class="item-img-content">
                <img
                  class="item-img"
                  :src="item.img"
                  alt
                  @click.self="toPage(item)"
                />
              </div>
              <div class="item-title">{{ item.title }}</div>
              <div
                v-if="isEdit"
                class="item-del-content"
                @click.stop="deleteListFn(index)"
              >
                <img
                  class="item-del-img"
                  src="@/assets/images/removeImg.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-list">
        <div
          v-for="(item, index) in appLocationList"
          :key="index"
          class="main-list-item"
        >
          <div class="list-item-title">
            {{ item.title }}
          </div>
          <CommonBorder></CommonBorder>
          <div class="list-item-content">
            <div
              v-for="(citem, cindex) in item.list"
              :key="cindex"
              class="item-items"
            >
              <div class="items-img-content">
                <img
                  class="items-img"
                  :src="citem.img"
                  alt
                  @click.self="toPage(citem)"
                />
              </div>
              <div class="items-title">
                {{ citem.title }}
              </div>
              <div
                v-if="isEdit"
                class="items-add-content"
                @click.stop="addListFn(citem)"
              >
                <img
                  class="items-add-img"
                  src="@/assets/images/addImg.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getReportMealConfig } from '@/api/report-meal';
import { getUserConfigAPI, editUserConfigAPI } from '@/api/api';
import CommonBorder from '@/components/commonBorder';
import topHeader from '@/components/topHeader';
import check from '@/assets/check.png';
import cancel from '@/assets/cancel.png';
import { Toast } from 'vant';
import faceReview from '@/assets/face-review.png';
import u286 from '@/assets/images/icon-pick-record.png';
import u287 from '@/assets/u287.png';
import allowance from '@/assets/app-img/allowance.png';
import leave from '@/assets/app-img/leave.png';
import order from '@/assets/app-img/order.png';
import consumption from '@/assets/app-img/consumption.png';
import rechargeHistory from '@/assets/app-img/rechargeHistory.png';
import paycode from '@/assets/app-img/paycode.png';
import recharge from '@/assets/app-img/recharge.png';
import mealCoupon from '@/assets/app-img/mealCoupon.png';
import checkWork from '@/assets/app-img/checkWork.png';
import informSetting from '@/assets/app-img/informSetting.png';
import accessRecord from '@/assets/app-img/accessRecord.png';
import inviteList from '@/assets/app-img/inviteList.png';
import passCode from '@/assets/app-img/passCode.png';
import examineAndApprove from '@/assets/app-img/examineAndApprove.png';
import classInform from '@/assets/app-img/classInform.png';
import faceCheck from '@/assets/app-img/faceCheck.png';
import reportMeal from '@/assets/app-img/icon-my-report-meal.png';
import allApp from '@/assets/app-img/allApp.png';
export default {
  components: { topHeader, CommonBorder },
  data() {
    return {
      cancel,
      list: [],
      loading: false,
      finished: false,
      homeApp: {},
      isEdit: false,
      appLocationList: [],
      titleList: [],
      pathList: []
    };
  },
  created() {
    this.displayAppListFn();
    this.getUserConfigFn();
  },
  methods: {
    isIncludesFunc(func) {
      let res = false;
      this.$store.getters.menuSetting.children.forEach((menu) => {
        if (menu.children && menu.children.length > 0) {
          menu.children.forEach((item) => {
            if (item.name === func) {
              res = true;
            }
          });
        }
      });
      return res;
    },
    toBack() {
      this.$router.push('/');
    },
    async toPage(item) {
      if (item.func === 'MyReportMeal') {
        const res = await getReportMealConfig();
        if (!res.data || res.data.open === 0) {
          this.$toast('未开启此功能，若需使用请联系管理员');
          return;
        }
      }
      if (!this.isEdit) {
        this.$router.push({ name: item.func });
      }
    },
    moveSpecificItems(arr) {
      const otherItems = arr.filter(
        (item) => item?.title !== '通知设置' && item?.title !== '出入记录'
      );

      const notifyItem = arr.find((item) => item?.title === '通知设置');
      const recordItem = arr.find((item) => item?.title === '出入记录');

      const result = [...otherItems];

      if (notifyItem) {
        result.splice(5, 0, notifyItem);
      }

      if (recordItem) {
        result.splice(6, 0, recordItem);
      }

      return result;
    },
    displayAppListFn() {
      const user = JSON.parse(sessionStorage.getItem('personInfo'));
      const isClassManager = user.isClassManager;
      const classManager = user.classManager;
      const role = user.role;
      const departmentManager = user.departmentManager;
      const isManager = user.isManager;
      this.appLocationList.push({
        title: '智慧食堂',
        list: [
          {
            img: allowance,
            title: `${
              this.$store.getters.symbolField === '积分' ? '积分' : '补助金'
            }`,
            func: 'Allowance'
          },
          { img: consumption, title: '消费明细', func: 'Consumption' },
          {
            img: rechargeHistory,
            title: '账单',
            func: 'RechargeHistory'
          },
          { img: paycode, title: '消费码', func: 'Paycode' },

          { img: recharge, title: '充 值', func: 'Recharge' },

          { img: order, title: '我的订餐', func: 'Order' },

          { img: mealCoupon, title: '我的餐券', func: 'Coupon' }
        ]
      });
      this.appLocationList.push({
        title: '智慧门禁',
        list: [
          { img: checkWork, title: '考勤管理', func: 'CheckWork' },

          { img: informSetting, title: '通知设置', func: 'SmsAuth' },
          { img: accessRecord, title: '出入记录', func: 'AccessRecord' }
        ]
      });

      if (role === 0 && this.isIncludesFunc('MyReportMeal')) {
        this.appLocationList.map((item) => {
          if (item.title === '智慧食堂') {
            // item.list.push({
            //   img: questionnaire,
            //   title: '问卷',
            //   func: 'Questionnaire'
            // });
            // abc新增我的报餐
            item.list.push({
              img: reportMeal,
              title: '我的报餐',
              func: 'MyReportMeal'
            });
          }
        });
      }
      if (role === 1) {
        if (classManager && this.isIncludesFunc('Leave')) {
          this.appLocationList.map((item) => {
            if (item.title === '智慧门禁') {
              item.list.push({
                img: leave,
                title: '请假',
                func: 'Leave'
              });
            }
          });
        }
        if (classManager && this.isIncludesFunc('PickRecords')) {
          this.appLocationList.map((item) => {
            if (item.title === '智慧门禁') {
              item.list.push({
                img: u286,
                title: '接送记录',
                func: 'PickRecords'
              });
            }
          });
        }
      } else {
        if (departmentManager && this.isIncludesFunc('Leave')) {
          this.appLocationList.map((item) => {
            if (item.title === '智慧门禁') {
              item.list.push({
                img: leave,
                title: '请假',
                func: 'Leave'
              });
            }
          });
        }
      }
      if (
        isClassManager ||
        (isManager && this.isIncludesFunc('ExamineLeave'))
      ) {
        this.appLocationList.forEach((item) => {
          if (item.title === '智慧门禁') {
            item.list.push({
              img: examineAndApprove,
              title: '审批',
              func: 'ExamineLeave'
            });
          }
        });
      }
      if (isClassManager && this.isIncludesFunc('ClassInform')) {
        this.appLocationList.forEach((item) => {
          if (item.title === '智慧门禁') {
            item.list.push({
              img: classInform,
              title: '上学管理',
              func: 'ClassInform'
            });
          }
        });
      }
      if (
        (departmentManager || isManager) &&
        this.isIncludesFunc('InviteList')
      ) {
        this.appLocationList.map((item) => {
          if (item.title === '智慧门禁') {
            item.list.push({
              img: inviteList,
              title: '访客邀请',
              func: 'InviteList'
            });
          }
        });
      }
      if ((departmentManager || isManager) && this.isIncludesFunc('PassCode')) {
        this.appLocationList.map((item) => {
          if (item.title === '智慧门禁') {
            item.list.push({
              img: passCode,
              title: '通行码',
              func: 'PassCode'
            });
          }
        });
      }
      const arr = [];
      this.$store.getters.menuSetting.children.forEach((item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((menu) => {
            arr.push(menu.name);
          });
        }
      });

      this.appLocationList.forEach((item) => {
        item.list = item.list.filter((cItem) => {
          return arr.some((menu) => menu === cItem.func);
        });
      });
      this.appLocationList = this.appLocationList.filter((item) => {
        return item.list.length > 0;
      });

      this.appLocationList.forEach((item) => {
        if (item.title === '智慧食堂') {
          if (isClassManager || isManager) {
            item.list.push({
              img: faceCheck,
              title: '人脸审批',
              func: 'FaceCheck'
            });
          }
        }
        if (item.title === '智慧门禁') {
          if (isClassManager || isManager) {
            item.list.push({
              img: faceCheck,
              title: '人脸审批',
              func: 'FaceCheck'
            });
          }
        }
      });
    },
    getUserConfigFn() {
      const user = JSON.parse(sessionStorage.getItem('personInfo'));
      getUserConfigAPI(user.id).then((res) => {
        if (res.code === 0) {
          if (res.data) {
            this.homeApp = res.data;
            this.homeApp.config = JSON.parse(this.homeApp.config);
            const arr = [];
            console.log(this.$store.getters.menuSetting.children);
            this.$store.getters.menuSetting.children.forEach((item) => {
              if (item.children && item.children.length > 0) {
                item.children.forEach((menu) => {
                  arr.push(menu.name);
                });
              }
            });
            this.homeApp.config = this.homeApp.config.filter((item) => {
              return arr.some((menu) => menu === item.func);
            });
            console.log(
              this.$store.getters.menuSetting.children,
              this.homeApp.config
            );
          } else {
            this.homeApp = {
              config: this.moveSpecificItems(
                (this.appLocationList || []).flatMap((item) => item?.list || [])
              ).slice(0, 7)
            };
            this.$set(this.homeApp, 'organizationId', user.organizationId);
            this.$set(this.homeApp, 'userId', user.id);
          }
          this.appLocationList.map((item) => {
            item.list.map((citem) => {
              this.titleList.push(citem.title);
              this.pathList.push(citem.func);
            });
          });
          let newArr = [];
          this.homeApp.config.map((item, index) => {
            if (
              !this.titleList.includes(item.title) ||
              !this.pathList.includes(item.func)
            ) {
              newArr.push(index);
            }
          });
          newArr = newArr.sort((a, b) => {
            return b - a;
          });
          newArr.map((item) => {
            this.homeApp.config.splice(item, 1);
          });
        }
      });
    },
    editUserConfigFn() {
      const user = JSON.parse(sessionStorage.getItem('personInfo'));
      this.$set(this.homeApp, 'organizationId', user.organizationId);
      this.$set(this.homeApp, 'userId', user.id);
      const from = JSON.parse(JSON.stringify(this.homeApp));
      from.config = JSON.stringify(from.config);
      editUserConfigAPI({
        ...from
      }).then((res) => {
        if (res.code === 0) {
          this.isEdit = false;
          Toast('编辑成功!');
          this.getUserConfigFn();
        }
      });
    },
    deleteListFn(index) {
      if (this.homeApp.config.length <= 1) {
        Toast('最少需要保留一个应用!');
      } else {
        this.homeApp.config.splice(index, 1);
      }
    },
    addListFn(val) {
      if (this.homeApp.config.length === 7) {
        Toast('最多只能配置7个应用!');
        return;
      }
      let flag = false;
      this.homeApp.config.map((item) => {
        if (item.title === val.title && item.func === val.func) {
          flag = true;
        }
      });
      if (flag) {
        Toast('已存在该应用!');
        return;
      }
      this.homeApp.config.push(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #f7f7f7;
  .main-content {
    flex: 1;
    width: 100%;
    overflow: auto;
    .main-top {
      box-sizing: border-box;
      padding: 0 16px;
      margin-top: 10px;
      .top-content {
        background: #fff;
        border-radius: 15px;
        .top-title-content {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 10px 16px;
          .top-title {
            color: #000;
            font-weight: bold;
          }
          .top-btn {
            width: 40px;
            border: 1px solid #fa5050;
            text-align: center;
            border-radius: 10px;
            font-size: 12px;
            height: 22px;
            line-height: 22px;
          }
        }
        .top-list-content {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          box-sizing: border-box;
          padding: 5px 0 16px;
          .top-list-item {
            width: 25%;
            text-align: center;
            position: relative;
            .item-img-content {
              width: 100%;
              margin-top: 16px;
              .item-img {
                width: 35%;
                height: 35%;
              }
            }
            .item-title {
              font-size: 14px;
            }
            .item-del-content {
              position: absolute;
              right: 8px;
              top: 8px;
              .item-del-img {
                width: 20px;
                height: 20px;
              }
            }
          }
        }
      }
    }
    .main-list {
      box-sizing: border-box;
      padding: 0 16px;
      margin-top: 28px;
      .main-list-item {
        background: #fff;
        border-radius: 15px;
        margin-bottom: 20px;
        .list-item-title {
          color: #000;
          font-weight: bold;
          box-sizing: border-box;
          padding: 10px 16px;
        }
        .list-item-content {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          box-sizing: border-box;
          padding: 5px 0 16px;
          .item-items {
            width: 25%;
            text-align: center;
            position: relative;
            .items-img-content {
              width: 100%;
              margin-top: 16px;
              .items-img {
                width: 35%;
                height: 35%;
              }
            }
            .items-title {
              font-size: 14px;
            }
            .items-add-content {
              position: absolute;
              right: 8px;
              top: 8px;
              .items-add-img {
                width: 20px;
                height: 20px;
              }
            }
          }
        }
      }
    }
  }
}
::v-deep .van-field__body {
  display: block;
  box-sizing: border-box;
  padding: 0 5px;
  height: 2.5rem;
  line-height: 2.5rem;
  border: 1px solid rgba(181, 201, 210, 0.6);
}
</style>
